<template>
  <div class="pt-8 px-5 color--nice-black">
    <v-slide-y-transition group hide-on-leave tag="div" class="height-100">
      <div v-if="ready" key="result">
        <div class="mb-5">
          <h1 class="font--m-1">우리동네 크라우드 펀딩<br />한도조회 결과</h1>
        </div>

        <div class="mb-4">
          <h1 class="amount">{{ commaFormat(amount) }} 원</h1>
        </div>

        <v-layout class="px-0 pb-7">
          <v-btn
            v-if="amount < 1"
            color="primary"
            block
            large
            depressed
            height="52"
            class="font--m-3"
            @click="$emit('reset')"
          >
            다시 조회하기
          </v-btn>
          <v-row v-else>
            <ConsultModal :open.sync="openModal" :uuid="uuid" />
          </v-row>
        </v-layout>

        <Description />
      </div>
      <div style="height: 300px" key="height300"></div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { commaFormat } from '@/filter/number'
import Description from './Description.vue'
import ConsultModal from './ConsultModal.vue'

export default {
  props: ['amount', 'uuid'],
  data() {
    return {
      ready: false,
      openModal: false,
    }
  },
  methods: {
    commaFormat,
    applyConsult() {
      this.openModal = true
    },
  },
  mounted() {
    this.ready = true
  },
  components: { Description, ConsultModal },
}
</script>

<style lang="scss" scoped>
.amount {
  font-size: 40px;
  font-weight: 900;
}
</style>
